import React, { useContext, useState, useEffect, useMemo } from 'react';
import DataTable from '../../Table';
import { SecretariasContext } from '../../../contexts/secretariasProvider';
import { BiX } from "react-icons/bi";
import BaseSelect from '../../General/FormsComp/Select/BaseSelect';

const VincularNovosPatrimonios = ({ secretaria, cliente, patrimonios, onBack, onVinculados }) => {
  const { updateSecretaria } = useContext(SecretariasContext);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Estados para o sistema de multi-seleção igual ao patrimonios.jsx
  const [selectedSetor, setSelectedSetor] = useState([]);
  const [selectedAnexos, setSelectedAnexos] = useState([]);
  const [setor, setSetor] = useState([]);
  const [anexos, setAnexos] = useState([]);
  const [showAnexos, setShowAnexos] = useState([]);
  const [selectedSetorValue, setSelectedSetorValue] = useState('');
  const [selectedAnexoValue, setSelectedAnexoValue] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [showSelections, setShowSelections] = useState(false);
  const [searchSetor, setSearchSetor] = useState('');
  const [searchAnexo, setSearchAnexo] = useState('');

  console.log(patrimonios);
  const headers = [
    { label: 'Etiqueta', key: 'nEtiqueta', sortable: true, width: 'w-1/10' },
    { label: 'Nome', key: 'nome', sortable: true, width: 'w-2/12', truncate: true },
    { label: 'Produto', key: 'produto', sortable: false, width: 'w-1/6' },
    { label: 'MAC', key: 'nMac', sortable: false, width: 'w-1/10' },
    { label: 'Setor', key: 'setor', sortable: false, width: 'w-1/10' },
    { label: 'Anexo', key: 'nome_anexo', sortable: false, width: 'w-1/6' },
    { label: "Secretaria", key: "secretaria_nome", sortable: false, width: 'w-1/10' }
  ];

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showFilters && !event.target.closest('.relative')) {
        setShowFilters(false);
      }
      if (showSelections && !event.target.closest('.relative')) {
        setShowSelections(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilters, showSelections]);

  // Inicializar listas de anexos e setores únicos
  const handleUnique = () => {
    const patrimoniosFiltered = patrimonios?.filter(pat => 
      pat.nome_anexo !== "ESTOQUE" && pat.nome_anexo !== "Estoque" && pat.nome_anexo !== "estoque"
    ) || [];
    
    const uniqueAnexos = [...new Set(patrimoniosFiltered.map(p => p.nome_anexo).filter(a => a && a !== null && a !== undefined))];
    const uniqueSetor = [...new Set(patrimoniosFiltered.map(p => p.setor).filter(s => s && s !== null && s !== undefined))];
    
    if (uniqueSetor.length > 1) {
      uniqueSetor.unshift('Todos');
      setSetor(uniqueSetor);
    }
    if (uniqueAnexos.length > 1) {
      uniqueAnexos.unshift('Todos');
      setAnexos(uniqueAnexos);
    }
  };

  useEffect(() => {
    handleUnique();
  }, [patrimonios]);

  // Manipulação dos filtros de anexo
  const handleAnexoChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedAnexoValue(selectedValue);
    if (selectedValue === 'Todos' && anexos.length > 1) {
      setSelectedAnexos(prev => {
        const anexosRestantes = anexos.filter((anexo) => anexo !== 'Todos' && !prev.includes(anexo));
        return [...prev, ...anexosRestantes];
      });
      setShowAnexos(prev => {
        const anexosRestantes = anexos.filter((anexo) => anexo !== 'Todos' && !prev.includes(anexo));
        return [...prev, ...anexosRestantes];
      });
    } else {
      setSelectedAnexos(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
      setShowAnexos(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
    }
  };

  // Manipulação dos filtros de setor
  const handleSetorChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedSetorValue(selectedValue);
    if (selectedValue === 'Todos' && setor.length > 1) {
      setSelectedSetor(prev => {
        const setoresRestantes = setor.filter((setor) => setor !== 'Todos' && !prev.includes(setor));
        return [...prev, ...setoresRestantes];
      });
    } else {
      setSelectedSetor(prev => {
        if (!prev.includes(selectedValue) && selectedValue !== 'Todos') {
          return [...prev, selectedValue];
        }
        return prev;
      });
    }
  };

  // Remover anexo específico
  const handleRemoveAnexo = (index) => {
    setSelectedAnexos(prev => {
      const removedAnexo = prev[index];
      setAnexos(prev => {
        if (!prev.includes(removedAnexo)) {
          return [...prev, removedAnexo];
        }
        return prev;
      });
      return prev.filter((_, i) => i !== index);
    });
    setShowAnexos(prev => {
      const removedAnexo = prev[index];
      setAnexos(prev => {
        if (!prev.includes(removedAnexo)) {
          return [...prev, removedAnexo];
        }
        return prev;
      });
      return prev.filter((_, i) => i !== index);
    });
  };

  // Remover setor específico
  const handleRemoveSetor = (index) => {
    setSelectedSetor(prev => {
      const removedSetor = prev[index];
      setSetor(prev => {
        if (!prev.includes(removedSetor)) {
          return [...prev, removedSetor];
        }
        return prev;
      });
      return prev.filter((_, i) => i !== index);
    });
  };

  // Remover todos os anexos
  const removeAllAnexos = () => {
    setSelectedAnexos([]);
    setShowAnexos([]);
    const patrimoniosFiltered = patrimonios?.filter(pat => 
      pat.nome_anexo !== "ESTOQUE" && pat.nome_anexo !== "Estoque" && pat.nome_anexo !== "estoque"
    ) || [];
    setAnexos(['Todos', ...new Set(patrimoniosFiltered.map(p => p.nome_anexo).filter(a => a && a !== null && a !== undefined))]);
  };

  // Remover todos os setores
  const removeAllSetores = () => {
    setSelectedSetor([]);
    const patrimoniosFiltered = patrimonios?.filter(pat => 
      pat.nome_anexo !== "ESTOQUE" && pat.nome_anexo !== "Estoque" && pat.nome_anexo !== "estoque"
    ) || [];
    setSetor(['Todos', ...new Set(patrimoniosFiltered.map(p => p.setor).filter(s => s && s !== null && s !== undefined))]);
  };

  // Filtrar dados com base nos filtros selecionados (usando padrão do patrimonios.jsx)
  const patrimoniosFiltrados = useMemo(() => {
    let filtered = (patrimonios || []).filter(p => p.nome_anexo !== "ESTOQUE" && p.nome_anexo !== "Estoque" && p.nome_anexo !== "estoque");
    
    if (selectedSetor.length > 0) {
      if (selectedAnexos.length > 0) {
        filtered = filtered.filter(p => selectedAnexos.includes(p.nome_anexo));
      } else {
        filtered = filtered.filter(p => selectedSetor.includes(p?.setor));
      }
    }
    
    if (selectedAnexos.length > 0) {
      if (selectedSetor.length > 0) {
        filtered = filtered.filter(p => selectedSetor.includes(p.setor));
      } else {
        filtered = filtered.filter(p => selectedAnexos.includes(p.nome_anexo));
      }
    }
    
    return filtered;
  }, [selectedSetor, selectedAnexos, patrimonios]);

  useEffect(() => {
    setSetor(prev => prev.filter(setor => !selectedSetor.includes(setor)));
  }, [selectedSetor]);

  const handleVincular = async () => {
    const selecionados = patrimoniosFiltrados.filter((p) => selectedIds.includes(p.id));
    const patsNfs = selecionados.filter(p => p.nfs).map(p => p.id);
    const pats = selecionados.filter(p => !p.nfs).map(p => p.id);
    const secretariaUpdate = { id: secretaria.id, patrimonios: pats, patrimoniosnfs: patsNfs };
    setLoading(true);
    try {
      await updateSecretaria(secretariaUpdate);
      onVinculados && onVinculados();
      onBack && onBack();
    } catch (e) {
      console.error('Erro ao vincular patrimônios:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Cabeçalho com botões de ação e filtros */}
      <div className="flex flex-wrap items-end gap-4 mb-6">
        <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Vincular novos patrimônios</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">{patrimoniosFiltrados.length} de {patrimonios?.length || 0} itens disponíveis</p>
        </div>

        <div className="relative ml-auto flex items-center gap-3">
          <button onClick={onBack} className="px-3 py-2 text-sm font-medium bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors duration-200">
            Voltar
          </button>
          
          <button
            onClick={() => setShowFilters(!showFilters)}
            className="w-full lg:w-auto inline-flex items-center justify-center px-4 py-2 bg-gradient-to-r from-vox-blue-600 to-vox-blue-700 hover:from-vox-blue-700 hover:to-vox-blue-800 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-blue-500 focus:ring-offset-2"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
            </svg>
            Filtros Avançados
            <svg className={`w-4 h-4 ml-2 transition-transform duration-200 ${showFilters ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          <button 
            onClick={handleVincular} 
            disabled={loading || selectedIds.length === 0} 
            className="px-4 py-2 text-sm font-medium bg-vox-green-600 hover:bg-vox-green-700 disabled:opacity-60 text-white rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:ring-offset-2 disabled:transform-none disabled:hover:scale-100"
          >
            {loading ? 'Vinculando...' : `Vincular selecionados (${selectedIds.length})`}
          </button>

          {/* Dropdown de Filtros */}
          {showFilters && (
            <div className="absolute top-full right-0 mt-2 w-96 bg-white dark:bg-gray-800 rounded-xl shadow-vox-2xl border border-gray-200 dark:border-gray-700 z-50">
              <div className="p-6 space-y-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                  Filtros Avançados
                </h3>

                {/* Setor */}
                <BaseSelect
                  label="Setor"
                  name="setor"
                  value={selectedSetorValue}
                  onChange={handleSetorChange}
                  options={setor.filter(s => s && s !== null && s !== undefined).map(s => ({ id: s, nome: s }))}
                  placeholder="Selecione o setor"
                  valueKey="id"
                  labelKey="nome"
                />

                {/* Anexo */}
                <BaseSelect
                  label="Anexo"
                  name="anexo"
                  value={selectedAnexoValue}
                  onChange={handleAnexoChange}
                  options={anexos.filter(a => a && a !== null && a !== undefined).map(a => ({ id: a, nome: a }))}
                  placeholder="Selecione o anexo"
                  valueKey="id"
                  labelKey="nome"
                />

                {/* Botões do Dropdown */}
                <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
                  <button
                    onClick={() => {
                      // Limpar todos os filtros
                      setSelectedSetorValue('');
                      setSelectedSetor([]);
                      setSelectedAnexoValue('');
                      setSelectedAnexos([]);
                      removeAllAnexos();
                      removeAllSetores();
                    }}
                    className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-600 border border-gray-300 dark:border-gray-500 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-500 transition-colors duration-200"
                  >
                    Limpar
                  </button>
                  <button
                    onClick={() => setShowFilters(false)}
                    className="px-4 py-2 bg-gradient-to-r from-vox-green-600 to-vox-green-700 hover:from-vox-green-700 hover:to-vox-green-800 text-white font-medium rounded-lg transition-all duration-200"
                  >
                    Aplicar
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Seleções Ativas - Dropdown inline */}
      {(selectedSetor.length > 0 || showAnexos.length > 0) && (
        <div className="mb-4">
          <div className="relative inline-block">
            <button
              onClick={() => setShowSelections(!showSelections)}
              className="inline-flex items-center px-3 py-2 bg-gradient-to-r from-vox-orange-600 to-vox-orange-700 
              hover:from-vox-orange-700 
              hover:to-vox-orange-800 text-white font-medium rounded-lg shadow-sm 
              hover:shadow-md transition-all duration-200 
              focus:outline-none focus:ring-2 
              focus:ring-vox-orange-500 focus:ring-offset-2
              text-black dark:text-white
              "
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
              Seleções Ativas ({selectedSetor.length + showAnexos.length})
              <svg className={`w-4 h-4 ml-2 transition-transform duration-200 ${showSelections ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {showSelections && (
              <div className="absolute top-full left-0 mt-2 w-[1200px] h-[760px] bg-gradient-to-br from-white to-gray-50/50 dark:bg-gradient-to-br dark:from-gray-800 dark:to-gray-900/50 rounded-2xl shadow-vox-2xl border border-gray-200/50 dark:border-gray-700/50 z-50 flex flex-col backdrop-blur-sm">
                <div className="p-8 flex-1 overflow-y-auto">
                  <div className="flex items-center justify-between mb-6">
                    <h3 className="text-2xl font-semibold text-gray-900 dark:text-white">
                      Filtros Aplicados
                    </h3>
                    <button
                      onClick={() => {
                        removeAllSetores();
                        removeAllAnexos();
                        setSearchSetor('');
                        setSearchAnexo('');
                        setShowSelections(false);
                      }}
                      className="px-6 py-3 text-lg font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-gradient-to-r from-red-100 to-red-200 hover:from-red-500 hover:to-red-600 dark:from-red-900/20 dark:to-red-800/20 dark:hover:from-red-600 dark:hover:to-red-700 rounded-xl border-2 border-red-300 dark:border-red-700/50 shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
                    >
                      Limpar tudo
                    </button>
                  </div>
                  
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Caixa de Setores */}
                    {selectedSetor.length > 0 && (
                      <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 dark:bg-gradient-to-br dark:from-blue-900/20 dark:to-blue-800/10 rounded-xl p-6 border border-blue-200/50 dark:border-blue-700/50 shadow-sm">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-lg font-semibold text-blue-800 dark:text-blue-300 flex items-center gap-3">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0h3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                            Setores ({selectedSetor.filter(setor => setor.toLowerCase().includes(searchSetor.toLowerCase())).length})
                          </h4>
                          <button
                            onClick={removeAllSetores}
                            className="text-sm font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-red-50 hover:bg-red-500 dark:bg-gray-700 dark:hover:bg-red-600 px-4 py-2 rounded-lg border-2 border-red-300 dark:border-red-700/50 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105"
                          >
                            Remover todos
                          </button>
                        </div>
                        
                        {/* Input de pesquisa para setores */}
                        <div className="relative mb-4">
                          <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                          <input
                            type="text"
                            placeholder="Pesquisar setores..."
                            value={searchSetor}
                            onChange={(e) => setSearchSetor(e.target.value)}
                            className="w-full pl-14 pr-4 py-4 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          />
          </div>

                        <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto">
                          {selectedSetor
                            .filter(setor => setor.toLowerCase().includes(searchSetor.toLowerCase()))
                            .map((setor, index) => {
                              const originalIndex = selectedSetor.findIndex(s => s === setor);
                              return (
                                <span
                                  key={`${setor}-${originalIndex}`}
                                  className="inline-flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-blue-50 to-blue-100 text-gray-900 dark:bg-gradient-to-r dark:from-blue-900/40 dark:to-blue-800/40 dark:text-blue-200 text-lg rounded-xl border border-blue-200/50 dark:border-blue-600/50 shadow-sm hover:shadow-md transition-all duration-200"
                                >
                  {setor}
                                  <button
                                    onClick={() => handleRemoveSetor(originalIndex)}
                                    className="text-gray-600 hover:text-red-600 hover:bg-white/80 dark:text-blue-300 dark:hover:text-red-400 dark:hover:bg-blue-700/50 rounded-full p-1 transition-all duration-200 hover:scale-110"
                                    title="Remover setor"
                                  >
                                    <BiX className="w-6 h-6" />
                                  </button>
                                </span>
                              );
                            })}
                        </div>
                      </div>
                    )}

                    {/* Caixa de Anexos */}
                    {showAnexos.length > 0 && (
                      <div className="bg-gradient-to-br from-green-50 to-green-100/50 dark:bg-gradient-to-br dark:from-green-900/20 dark:to-green-800/10 rounded-xl p-6 border border-green-200/50 dark:border-green-700/50 shadow-sm">
                        <div className="flex items-center justify-between mb-4">
                          <h4 className="text-lg font-semibold text-green-800 dark:text-green-300 flex items-center gap-3">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Anexos ({showAnexos.filter(anexo => anexo.toLowerCase().includes(searchAnexo.toLowerCase())).length})
                          </h4>
                          <button
                            onClick={removeAllAnexos}
                            className="text-sm font-bold text-red-700 hover:text-white dark:text-red-400 dark:hover:text-white bg-red-50 hover:bg-red-500 dark:bg-gray-700 dark:hover:bg-red-600 px-4 py-2 rounded-lg border-2 border-red-300 dark:border-red-700/50 shadow-sm hover:shadow-md transition-all duration-200 transform hover:scale-105"
                          >
                            Remover todos
                          </button>
                        </div>
                        
                        {/* Input de pesquisa para anexos */}
                        <div className="relative mb-4">
                          <svg className="absolute left-4 top-1/2 transform -translate-y-1/2 w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                          <input
                            type="text"
                            placeholder="Pesquisar anexos..."
                            value={searchAnexo}
                            onChange={(e) => setSearchAnexo(e.target.value)}
                            className="w-full pl-14 pr-4 py-4 text-lg bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                          />
          </div>

                        <div className="flex flex-wrap gap-2 max-h-96 overflow-y-auto">
                          {showAnexos
                            .filter(anexo => anexo.toLowerCase().includes(searchAnexo.toLowerCase()))
                            .map((anexo, index) => {
                              const originalIndex = showAnexos.findIndex(a => a === anexo);
                              return (
                                <span
                                  key={`${anexo}-${originalIndex}`}
                                  className="inline-flex items-center gap-3 px-5 py-4 bg-gradient-to-r from-green-50 to-green-100 text-gray-900 dark:bg-gradient-to-r dark:from-green-900/40 dark:to-green-800/40 dark:text-green-200 text-lg rounded-xl border border-green-200/50 dark:border-green-600/50 shadow-sm hover:shadow-md transition-all duration-200"
                                >
                                  {anexo}
            <button
                                    onClick={() => handleRemoveAnexo(originalIndex)}
                                    className="text-gray-600 hover:text-red-600 hover:bg-white/80 dark:text-green-300 dark:hover:text-red-400 dark:hover:bg-green-700/50 rounded-full p-1 transition-all duration-200 hover:scale-110"
                                    title="Remover anexo"
            >
                                    <BiX className="w-6 h-6" />
            </button>
                                </span>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
            </div>
            )}
          </div>
        </div>
      )}

      <DataTable
        data={patrimoniosFiltrados}
        headers={headers}
        checkboxColumn
        onSelectionChange={setSelectedIds}
        exportButton={true}
        docTitle={`Vincular Patrimônios - ${secretaria?.nome} - ${cliente?.nome}`}
      />
    </div>
  );
}

export default VincularNovosPatrimonios;


